import * as t from '../action-types'

const dataExportMount = () => ({ type: t.EXPORT_DATACLIP_MOUNT })

export default dataExportMount
